import styled, { css } from "styled-components";

interface ICardContainerProps {
  isLesson: boolean;
}

export const CardContainer = styled.li<ICardContainerProps>`
  aspect-ratio: 16/9;
  margin-bottom: 1.75rem;

  a {
    :hover,
    :active,
    :focus {
      transform: scale(1.02);
      box-shadow: 0px 0px 0px 3px
        ${({ theme }) => theme.colors.searchPage.cardHoverBorderColor};
    }
  }

  a {
    div[data-testid="fallback-background"] {
      min-width: 100%;
      min-height: 100%;
    }

    img {
      width: 100%;
    }
  }

  a {
    position: relative;
    display: flex;
    flex-direction: column;
    transition: 0.3s all;

    .image-container {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      height: 100%;

      .player-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        background-color: #00000029;
        border-radius: 80rem;
        width: 5rem;
        height: 5rem;
        z-index: 2;

        svg {
          fill: #fff;
          width: 1.667rem;
          height: 2.083rem;
          position: relative;
          left: 3px;
        }
      }

      img {
        ${({ isLesson }) =>
          isLesson &&
          css`
            filter: brightness(70%);
          `}
        object-fit: cover;
        height: auto;
        z-index: 1;
        height: 100%;
      }
    }
  }

  .title {
    color: ${({ theme }) => theme.groups.primaryText} !important;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    max-width: 300px;
    text-overflow: ellipsis;

    font: 500 0.875rem / 1.25rem "Inter";
    margin-top: 0.5rem;
    margin-bottom: 0;
  }

  .group-title {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    max-width: 300px;
    text-overflow: ellipsis;

    font: 400 0.75rem/1.125rem "Inter";
    color: ${({ theme }) => theme.groups.secondaryText} !important;
    margin: 0;
  }

  a,
  img,
  [data-testid="fallback-background"] {
    border-radius: 4px;
    aspect-ratio: 16/9;
  }

  @media (max-width: 600px) {
    width: -webkit-fill-available;
  }
`;
